import { connect } from "react-redux";
import { ReduxState } from "../../store/state";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Text,
  Button,
  Box,
} from '@chakra-ui/react'
import { useState } from "react";
import { BusinessItem } from "../../store/page/types";
import { Cart, CartItem } from "../../store/cart/types";
import { asyncCartCreate } from "../../store/cart/initiators";
import CartItemCard from "../../components/cart/CartItemCard";
import { asyncRemoveItemFromCart, asyncUpdateItemInCart, asyncClearCart } from "../../store/cart/initiators";
import { updateCartSuccess } from "../../store/cart/actions";
import CartSummary from "../../components/cart/CartSummary";
import CartCheckoutForm from "./CartCheckoutForm";
import { asyncCalculateCartFees, asyncCartOrdersCreate } from "../../store/cart/initiators";
import CartChoosePaymentForm from "./CartChoosePaymentForm";
import CartPostCheckout from "./CartPostCheckout";

interface CartCheckoutFlowProps {
  cart: Cart | null;
  itemReferences: BusinessItem[];
  groupedCartItems?: Record<string, CartItem[]> 
  asyncCartCreate: () => void;
  updateCartSuccess: (cart: Cart) => void;
  asyncRemoveItemFromCart: (cartItemId: string) => void;
  asyncUpdateItemInCart: (cartItemId: string, quantity: number, price: number, currency: string, data?: any) => void;
  asyncClearCart: () => void;
  asyncCalculateCartFees: () => void;
  asyncCartOrdersCreate: () => void;
}

const CartCheckoutFlow: React.FC<CartCheckoutFlowProps> = ({ 
  cart, itemReferences, groupedCartItems,
  asyncRemoveItemFromCart, asyncUpdateItemInCart, asyncClearCart, updateCartSuccess, asyncCalculateCartFees, asyncCartOrdersCreate
}) => {

  const [cartStep, setCartStep] = useState(0)
  // 0 - Checkout Button - active if > 0 items
  // 1 - Checkout Form - choose delivery location
  // 2 - Choose Payment Form
  // 3 - Post Checkout

  const showToast = (text: string) => {
    toast.success(text, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3500,
    });
  };

  if (!cart) {
    return null;
  }

  if (cartStep === 0) {
    return (
      <>
        <CartSummary cart={cart} goForward={() => setCartStep(1)}/>
        <Button size={'xs'} mb={1} mt={1} onClick={() => {
          asyncClearCart()
          showToast('Removed all items from your cart')
          }}>Remove all items
        </Button>
        <ToastContainer />
        {groupedCartItems &&
        Object.entries(groupedCartItems).map(([businessLocationId, items]) => {
          return (
          <Box key={businessLocationId} mb={6}>
            <Text fontSize="xs" color="gray.600" mb={2}>
              Shipping from the same location (grouped into one order)
            </Text>
            {items.map((item) => (
              <CartItemCard 
              cart={cart}
              cartItem={item} 
              itemReferences={itemReferences} 
              key={item._id} 
              updateCartSuccess={updateCartSuccess}
              asyncRemoveItemFromCart={asyncRemoveItemFromCart} 
              asyncUpdateItemInCart={asyncUpdateItemInCart}
              showToast={showToast}
            />
            ))}
          </Box>
        )})}
      </>
    );
  } else if (cartStep === 1) {
    return (
            <CartCheckoutForm 
              groupedCartItems={groupedCartItems} 
              goForward={() => {
                asyncCalculateCartFees()
                setCartStep(2)
              }}
              goBack={() => setCartStep(0)}
            />
          );
  } else if (cartStep === 2) {
    return (
      <CartChoosePaymentForm
      groupedCartItems={groupedCartItems} 
      goForward={() => {
        asyncCartOrdersCreate()
        setCartStep(3)
      }}
      goBack={() => setCartStep(1)}
      />
    )
  } else if (cartStep === 3) {
    return (
      <CartPostCheckout />
    )
  } else {
    return null;
  }
};

const mapStateToProps = (state: ReduxState) => {
  const { cart, itemReferences } = state.cart;
  return { cart, itemReferences };
};

export default connect(mapStateToProps, {
  asyncCartCreate,
  asyncRemoveItemFromCart,
  asyncClearCart,
  asyncUpdateItemInCart,
  updateCartSuccess,
  asyncCalculateCartFees,
  asyncCartOrdersCreate
})(CartCheckoutFlow);